import './Company.css';
import React, { useEffect } from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { connect } from 'react-redux';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import Button from '@mui/material/Button';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import Pagination from '@mui/material/Pagination';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import UnpublishedIcon from '@mui/icons-material/Unpublished';

import CompanyDialog from '../../blocks/CompanyDialog/CompanyDialog';

import {
    GetCompany,
    CreateNewCompany,
    UpdateCompany,
    InactiveCompany,
    ActiveCompany,
    DeleteCompany,
} from '../../../services/Company.service';

import {
    DisableSchedule,
} from '../../../services/Schedule.service';

const innerHeight = window.innerHeight;

function Company(props) {
    const { translate, SnackbarAlert, ConfirmDialog } = props;
    const [selected, setSelected] = React.useState([]);
    const [searchCompany, setSearchCompany] = React.useState("");
    const [rowsPerPage, setRowsPerPage] = React.useState(50);
    const [pageCount, setPageCount] = React.useState(0);
    const [page, setPage] = React.useState(0);
    const [companylist, setCompanylist] = React.useState([]);
    const [openCompanyDialog, setOpenCompanyDialog] = React.useState(false);
    const dataCompanyRef = React.useRef();

    const onInit = () => {
        if(!searchCompany) props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: true });
        GetCompany(searchCompany, rowsPerPage, page)
        .then(res => {
            // console.log(res)
            setPageCount(Math.ceil(res.data.datas[0][0]?.count / rowsPerPage));
            setCompanylist(res.data.datas[1]);
            props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: false });
        })
        .catch(err => {
            // console.log(err);
            navigator("/signin");
            props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: false });
        });
    }

    const isSelected = (id) => selected.indexOf(id) !== -1;

    const handleChangeRowsPerPage = (event) => {
        setPage(0);
        setRowsPerPage(event.target.value);
    };
    const handleChangePage = (event, value) => {
        setPage(parseInt(value) - 1);
    };

    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked && selected.length === 0) {
            const newSelecteds = companylist.map((n) => n.companyID);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClickAddNew = () => {
        dataCompanyRef.current = undefined;
        setOpenCompanyDialog(true);
    }
    const handleClickEdit = (companyID) => {
        dataCompanyRef.current = companylist.find(company => company.companyID === companyID);
        setOpenCompanyDialog(true);
    }
    const handleClickAgree = async (company) => {
        let event;
        if(!company?.companyID) {
            event = CreateNewCompany(company);
        } else {
            event = UpdateCompany(company);
        }

        event?.then(res => {
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: res?.data?.status,
                        message: translate(`${res?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
                onInit();
            }, 1000)
        })
        .catch(err => {
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: err?.response?.data?.status,
                        message: translate(`${err?.response?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
            }, 1000)
        })
        .finally(() => setOpenCompanyDialog(false))
    }
    const handleClickClose = () => {
        dataCompanyRef.current = undefined;
        setOpenCompanyDialog(false);
    }

    const handleClickButton = (title) => {
        props.dispatch({ 
          type: 'UPDATE_CONFIRMDIALOG', 
          ConfirmDialog: {
            open: true,
            title: translate(`${title}`),
            message: translate('confirmactioncompany', { action: `${translate(`${title}`)}`?.toLowerCase() }),
            buttonName: translate(`${title}`),
            onClose: () => handleCloseConfirmDialog(),
            onAgree: () => {
                if(title === 'inactive') return handleClickInactive();
                if(title === 'active') return handleClickActive();
                if(title === 'delete') return handleClickDelete();
            }
          } 
        });
    };

    const handleCloseConfirmDialog = () => {
        props.dispatch({ type: 'UPDATE_CONFIRMDIALOG', ConfirmDialog: {...ConfirmDialog, open: false} });
    }

    const handleClickInactive = () => {
        if(selected.length > 0) {
            handleCloseConfirmDialog();
            InactiveCompany(selected)
            .then(res => {
                DisableSchedule(res.data.scheduleIDs);
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: res?.data?.status,
                        message: translate(`${res?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
                onInit();
            })
            .catch(err => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: err?.response?.data?.status,
                        message: translate(`${err?.response?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
            })
        }
    }

    const handleClickActive = () => {
        if(selected.length > 0) {
            handleCloseConfirmDialog();
            ActiveCompany(selected)
            .then(res => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: res?.data?.status,
                        message: translate(`${res?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
                onInit();
            })
            .catch(err => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: err?.response?.data?.status,
                        message: translate(`${err?.response?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
            })
        }
    }

    const handleClickDelete = () => {
        if(selected.length > 0) {
            handleCloseConfirmDialog();
            DeleteCompany(selected)
            .then(res => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: res?.data?.status,
                        message: translate(`${res?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
                onInit();
            })
            .catch(err => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: err?.response?.data?.status,
                        message: translate(`${err?.response?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
            })
        }
    }

    const handleCloseSnackbarAlert = () => {
        props.dispatch({ type: 'UPDATE_SNACKBARALERT', SnackbarAlert: { ...SnackbarAlert, open: false } });
    }

    useEffect(() => {
        setSelected([]);
    }, [companylist.length])

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        onInit();
    }, [searchCompany, rowsPerPage, page])

    return (
        <Container maxWidth="xl">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Box className='company-box'>
                        <Grid item xs={12}>
                            <Box sx={{ 
                                    p: 1, 
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}>
                                <Box className='search-box'>
                                    <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
                                        <SearchIcon />
                                    </IconButton>
                                    <InputBase
                                        type="search"
                                        sx={{ ml: 1, flex: 1 }}
                                        placeholder={translate('search')}
                                        onChange={(e) => setSearchCompany(e.target.value)}
                                    />
                                </Box>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                    {selected.length > 0 && 
                                    <Box>
                                        <Button variant="contained" disableElevation color='error' startIcon={<DeleteOutlineIcon />} onClick={() => handleClickButton('delete')}>{translate('delete')}</Button>
                                    </Box>}
                                    {selected.length > 0 && 
                                    <Box>
                                        <Button variant="contained" disableElevation color='info' startIcon={<CheckCircleIcon />} onClick={() => handleClickButton('active')}>{translate('enable')}</Button>
                                    </Box>}
                                    {selected.length > 0 && 
                                    <Box>
                                        <Button variant="contained" disableElevation color='secondary' startIcon={<UnpublishedIcon />} onClick={() => handleClickButton('inactive')}>{translate('disable')}</Button>
                                    </Box>}
                                    <Box>
                                        <Button variant="contained" disableElevation startIcon={<AddIcon />} onClick={handleClickAddNew}>{translate('addnew')}</Button>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                        <TableContainer sx={{ height: (innerHeight - 64 - 77 - 49) }}>
                            <Table stickyHeader size="small" sx={{ minWidth: 650 }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell padding="checkbox">
                                            <Checkbox 
                                                color="primary"
                                                indeterminate={selected.length > 0 && selected.length < companylist.length}
                                                checked={companylist.length > 0 && selected.length === companylist.length}
                                                onChange={handleSelectAllClick}
                                            />
                                        </TableCell>
                                        <TableCell>{translate('id')}</TableCell>
                                        <TableCell>{translate('companyname')}</TableCell>
                                        <TableCell align="center">{translate('status')}</TableCell>
                                        <TableCell align="center">{translate('telnumber')}</TableCell>
                                        <TableCell align="center">{translate('users')}</TableCell>
                                        <TableCell align="center">{translate('expiration')}</TableCell>
                                        <TableCell align="center">{translate('remarks')}</TableCell>
                                        <TableCell align="center">{translate('action')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {companylist.map((row, index) => (
                                    <TableRow
                                        hover
                                        tabIndex={-1}
                                        key={row.companyID}
                                    >
                                        <TableCell padding="checkbox">
                                            <Checkbox 
                                                color="primary"
                                                checked={isSelected(row.companyID)}
                                                onClick={(event) => handleClick(event, row.companyID)}
                                            />
                                        </TableCell>
                                        <TableCell align="left">{row.ID}</TableCell>
                                        <TableCell align="left">{row.companyName}</TableCell>
                                        <TableCell align="center">
                                            <Chip label={row.delFlg === 1 ? translate('deleted') : row.statusCd === 0 ? translate('active') : translate('inactive')} size="small" color={row.delFlg === 1 ? 'error' : row.statusCd === 0 ? 'info' : 'secondary'} />
                                        </TableCell>
                                        <TableCell align="center">{row.telNumber}</TableCell>
                                        <TableCell align="center">{row.numberOfUser}</TableCell>
                                        <TableCell align="center">{row.endDate}</TableCell>
                                        <TableCell align="left">{row.remarks}</TableCell>
                                        <TableCell align="center">
                                            <IconButton className='edit-button' onClick={() => handleClickEdit(row.companyID)}>
                                                <EditOutlinedIcon color="secondary" />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Grid item xs={12}>
                            <Box display="flex" justifyContent="space-between" p={1}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <span>{translate('rowsperpage')}:</span>
                                    <FormControl sx={{ mr: 1 }} size="small">
                                        <Select
                                            value={rowsPerPage}
                                            onChange={handleChangeRowsPerPage}
                                            displayEmpty
                                            autoWidth
                                            sx={{ "& > div": { padding: "5px 10px" }, "& > fieldset": { borderColor: "rgb(229, 234, 242)" } }}
                                        >
                                            {[50, 100, 200].map(item => (
                                                <MenuItem value={item}>{item}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                                <Pagination 
                                    shape="rounded" 
                                    count={pageCount}
                                    page={page + 1}
                                    onChange={handleChangePage}
                                    color="primary" 
                                />
                            </Box>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
            <CompanyDialog 
                open={openCompanyDialog}
                data={dataCompanyRef.current}
                handleAgree={handleClickAgree}
                handleClose={handleClickClose}
            />
        </Container>
    );
}
function mapStateToProps(state) {
    return {
      SnackbarAlert: state.SnackbarAlert,
      ConfirmDialog: state.ConfirmDialog,
    }
}
export default connect(mapStateToProps)(withTranslate(Company));